module.exports = __webpack_public_path__ + "img/thumb_settings_orders.4b4a6648.jpg";